import { IGame } from "../types/game";
import GameState from "./game-state";
import CheckLineState from "./check-line-state";
import PlayerAddBonusState from "./add-bonus-state";
import { StampBlockPacket } from "../../protocol/packets";

import { BLOCK_MATRIX } from "../models/block";

export default class StampBlockState extends GameState {
  private hasBonus: boolean = false;

  constructor(game: IGame, packet?: StampBlockPacket) {
    super(game);
    
    // For remote players, sync bloc position from packet (matches original player.cc:1407-1409)
    if (packet && this.canvas.bloc) {
      this.canvas.bloc.rotation = packet.rotation;
      this.canvas.bloc.x = packet.x;
      this.canvas.bloc.y = packet.y;
    }

    for (let j = 0; j < 36; j++) {
      for (let i = 0; i < 18; i++) {
        this.canvas.moved[j][i] = false;
      }
    }

    this.canvas.idle = 0;

    // Track piece statistics BEFORE stamping (matches original player.cc:1422-1423)
    // Reference: quadra/source/player.cc:1422-1423
    // Original tracks stats in Player_stamp constructor before stamp_bloc() is called
    if (this.canvas.bloc && this.game.stats) {
      const pieceType = this.canvas.bloc.quel;
      const compteStat = `COMPTE${pieceType}` as keyof typeof this.game.stats;
      if (this.game.stats[compteStat]) {
        this.game.stats[compteStat].add(1);
      }
      if (this.game.stats["COMPTETOT"]) {
        this.game.stats["COMPTETOT"].add(1);
      }
    }

    this.stampBlock();

    // Match original C++ check exactly: if(canvas->bonus && !canvas->bon[0].blind_time)
    // Original assumes bon[0] exists when bonus > 0 (which it should, since we add entries starting at index 0)
    // Add safety check: ensure bon[0] exists before accessing it
    this.hasBonus =
      this.canvas.bonus > 0 &&
      this.canvas.bon[0] !== undefined &&
      !this.canvas.bon[0].blind_time;

    const stampSounds = ["depose1", "depose2"];
    const randomSoundIndex = Math.floor(Math.random() * stampSounds.length);
    const selectedSound = stampSounds[randomSoundIndex];
    const randomPitch = 1.0 + (Math.random() - 0.5) * 0.1;
    this.game.audioManager.playSound(selectedSound, randomPitch);

    // NOTE: Don't clear bloc here! It's cleared in enter() after CheckLineState
    // This matches original: bloc is cleared after Player_check_line
  }

  enter(): void {
    // Note: In original C++, P_CLIENTSTAMPBLOCK is sent BEFORE Player_stamp is created
    // (in Player_process_key::step() line 480), not here in Player_stamp::init()
    // Our implementation now sends it in ProcessKeyState.moveBlockY() to match original

    this.call(new CheckLineState(this.game));
    if (this.hasBonus) {
      this.call(new PlayerAddBonusState(this.game));
    }
    this.call(new CheckLineState(this.game));

    // Clear bloc AFTER check lines (matches original behavior)
    this.canvas.bloc = null;
    if (this.canvas.blocShadow) {
      this.canvas.blocShadow = null;
    }

    this.game.popState(this);
  }

  stampBlock() {
    if (!this.canvas.bloc) return;
    
    let t: number;
    for (let j = 0; j < 4; j++) {
      for (let i = 0; i < 4; i++) {
        t =
          BLOCK_MATRIX[this.canvas.bloc.quel][this.canvas.bloc.rotation][j][
            i
          ];
        if (t) {
          this.canvas.blocks[this.canvas.bloc.y + j][this.canvas.bloc.x + i] =
            t + (this.canvas.bloc.quel << 4);
          this.canvas.occupied[this.canvas.bloc.y + j][
            this.canvas.bloc.x + i
          ] = true;
          this.canvas.dirted[this.canvas.bloc.y + j][
            this.canvas.bloc.x + i
          ] = 2;
          this.canvas.moved[this.canvas.bloc.y + j][this.canvas.bloc.x + i] =
            true;
        }
      }
    }
  }

  update(frameTime: number): void {
    super.update(frameTime);
  }

  toString(): string {
    return "Stamp Block";
  }
}
